<template>
  <div class="palette-container">
    <div class="data-elements">
      <div class="create-element-container">
        <div class="test-record">
          <span v-if="testRecord">
            {{ previewText }}: {{ testRecordName }}
          </span>
        </div>
        <div class="element-btn-wrapper">
          <button class="create-element-btn" v-b-modal.new-data-element-wizard>
            {{ newDEButtonText }}
          </button>
        </div>
        <new-data-element-wizard
          :types="deTypes"
          :appId="appId"
          :title="newDEButtonText"
          @de-created="onDECreated"
        ></new-data-element-wizard>
      </div>
    </div>

    <transition name="loader">
      <div class="loader-wrapper" v-if="displayLoader">
        <div class="loader"></div>
      </div>
    </transition>

    <div class="elements-container" v-if="hasDes && shouldShow">
      <b-tabs nav-class="tabs-left-column" card vertical v-model="tabIndex">
        <b-tab
          :title="de.name"
          v-for="(de, key, index) in updatedApp.dataElements"
          :key="key"
          @click="onTabClicked(index)"
        >
          <base-card
            :header-class="getHeaderClass(de)"
            :no-padding="isMergeList(de)"
            :no-margin="isMergeList(de)"
          >
            <template v-slot:header>
              <div class="de-header-row">
                <div class="de-title">{{ de.name }}</div>
                <div class="de-btn-wrapper">
                  <button
                    class="de-edit-btn"
                    v-b-modal="getQueryModalId(de.type, de.id)"
                  >
                    {{ messages.Edit.Text_vod__c }}
                  </button>
                </div>
                <context-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_CONTEXT_QUERY'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                  @de-modal-closed="onDECreateModalClose()"
                ></context-edit-modal>
                <CRM-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_CRM_QUERY'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                  @de-modal-closed="onDECreateModalClose()"
                ></CRM-edit-modal>
                <sales-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_SALES_DATA_QUERY'"
                  :appType="updatedApp.type"
                  :all-des="updatedApp.dataElements"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></sales-edit-modal>
                <one-one-edit-modal
                  :appId="appId"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></one-one-edit-modal>
                <field-translation-edit
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_FIELD_TRANSLATION'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></field-translation-edit>
                <summarize-edit
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_SUMMARIZE'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></summarize-edit>
                <object-translation-edit
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_OBJECT_TRANSLATION'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></object-translation-edit>
                <Vmsg-edit
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_VEEVA_MESSAGES'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></Vmsg-edit>
                <sublist-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_SUBLIST'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></sublist-edit-modal>
                <sort-list-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_SORT_LIST'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></sort-list-edit-modal>
                <merge-list-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_MERGE_LIST'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></merge-list-edit-modal>
                <filter-list-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_FILTER_LIST'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></filter-list-edit-modal>
                <nitro-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_NITRO_QUERY'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></nitro-edit-modal>
                <today-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_TODAY'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></today-edit-modal>
                <now-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_NOW'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></now-edit-modal>
                <dropdown-edit-modal
                  :appId="appId"
                  v-if="de.type === dataElementTypes.DROPDOWN"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></dropdown-edit-modal>
                <datepicker-edit-modal
                  :appId="appId"
                  v-if="de.type === dataElementTypes.DATEPICKER"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></datepicker-edit-modal>
                <aligned-territories-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_ALIGNED_TERRITORIES'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></aligned-territories-edit-modal>
                <data-engine-edit-modal
                  :appId="appId"
                  v-if="de.type === dataElementTypes.CRM_DATA_ENGINE"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></data-engine-edit-modal>
                <feedback-overview-edit-modal
                  :appId="appId"
                  v-if="de.type === dataElementTypes.FEEDBACK_OVERVIEW"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></feedback-overview-edit-modal>
                <feedback-channel-goals-edit-modal
                  :appId="appId"
                  v-if="de.type === dataElementTypes.FEEDBACK_CHANNEL_GOALS"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></feedback-channel-goals-edit-modal>
                <feedback-product-goals-edit-modal
                    :appId="appId"
                    v-if="de.type === dataElementTypes.FEEDBACK_PRODUCT_GOALS"
                    :all-des="updatedApp.dataElements"
                    :appType="updatedApp.type"
                    :de="de"
                    :id="de.id"
                    :name="de.name"
                ></feedback-product-goals-edit-modal>
                <feedback-account-data-edit-modal
                    :appId="appId"
                    v-if="de.type === dataElementTypes.FEEDBACK_ACCOUNT_DATA"
                    :all-des="updatedApp.dataElements"
                    :appType="updatedApp.type"
                    :de="de"
                    :id="de.id"
                    :name="de.name"
                ></feedback-account-data-edit-modal>
                <feedback-account-channel-goals-edit-modal
                    :appId="appId"
                    v-if="de.type === dataElementTypes.FEEDBACK_ACCOUNT_CHANNEL_GOALS"
                    :all-des="updatedApp.dataElements"
                    :appType="updatedApp.type"
                    :de="de"
                    :id="de.id"
                    :name="de.name"
                ></feedback-account-channel-goals-edit-modal>
                <feedback-account-product-goals-edit-modal
                    :appId="appId"
                    v-if="de.type === dataElementTypes.FEEDBACK_ACCOUNT_PRODUCT_GOALS"
                    :all-des="updatedApp.dataElements"
                    :appType="updatedApp.type"
                    :de="de"
                    :id="de.id"
                    :name="de.name"
                ></feedback-account-product-goals-edit-modal>
                <feedback-account-product-metrics-edit-modal
                    :appId="appId"
                    v-if="de.type === dataElementTypes.FEEDBACK_ACCOUNT_PRODUCT_METRICS"
                    :all-des="updatedApp.dataElements"
                    :appType="updatedApp.type"
                    :de="de"
                    :id="de.id"
                    :name="de.name"
                ></feedback-account-product-metrics-edit-modal>
                <call-attendees-edit-modal
                  :appId="appId"
                  v-if="de.type === 'DATA_EL_CALL_ATTENDEES'"
                  :all-des="updatedApp.dataElements"
                  :appType="updatedApp.type"
                  :de="de"
                  :id="de.id"
                  :name="de.name"
                ></call-attendees-edit-modal>
              </div>
              <div class="de-description">{{ de.description }}</div>
            </template>
            <query-base-card
              :deType="de.type"
              :deId="key"
              :appId="appId"
              :appType="updatedApp.type"
              :key="key"
            ></query-base-card>
          </base-card>

          <base-card
            class="preview-wrapper"
            header-class="de-header"
            v-if="isActiveTab(index)"
          >
            <template v-slot:header>
              <div class="de-header-row">
                <div class="de-title">{{ previewText }}</div>
                <div class="de-btn-wrapper">
                  <svg class="de-refresh-icon" @click="refreshPreview(de.id)">
                    <use
                      xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#refresh"
                    ></use>
                  </svg>
                </div>
              </div>
            </template>
            <div class="preview-content">
              <preview :ref="`preview-${de.id}`" :de-id="de.id"></preview>
            </div>
          </base-card>

          <div class="action-row">
            <button
              class="modal-btn delete-btn"
              @click="deleteElement(de.id)"
              v-if="!shouldHideDelete(de.type)"
            >
              {{ deleteLabel }}
            </button>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
  import NewDataElementWizard from "../components/NewDataElementWizard";
  import BaseCard from "@/components/card/BaseCard";
  import QueryBaseCard from "@/components/queries/QueryBaseCard";
  import ContextEditModal from "@/components/queries/context-queries/ContextEditModal";
  import CRMEditModal from "@/components/queries/crm-queries/CRMEditModal";
  import VmsgEdit from "@/components/VmsgEdit";
  import OneOneEditModal from "@/components/queries/OneOneCalculation/OneOneEditModal";
  import SummarizeEdit from "@/components/calculations/Summarize/SummarizeEdit";
  import ObjectTranslationEdit from "@/components/ObjectTranslationEdit";
  import SublistEditModal from "@/components/queries/sublist/SublistEditModal";
  import SortListEditModal from "@/components/queries/sort-list/SortListEditModal";
  import MergeListEditModal from "@/components/queries/merge-list/MergeListEditModal";
  import FilterListEditModal from "@/components/queries/filter-list/FilterListEditModal";
  import FieldTranslationEdit from "@/components/FieldTranslationEdit";
  import SalesEditModal from "@/components/queries/sales-data/SalesEditModal";
  import TodayEditModal from "@/components/TodayEditModal";
  import NowEditModal from "@/components/NowEditModal";
  import DropdownEditModal from "@/components/DropdownEditModal";
  import DatepickerEditModal from "@/components/DatepickerEditModal";
  import DataEngineEditModal from "@/components/queries/crm-data-engine/DataEngineEditModal";
  import Preview from "@/components/Preview";
  import utils from "@/utils";
  import store from "@/store";
  import debounce from "lodash.debounce";
  import {
    MUTATION_NAME,
    EDIT_MODAL_TYPES,
    DATA_ELEMENT_TYPE,
    DATA_ELEMENT_TYPE_TO_LABEL
  } from "@/static/global-variables";
  import { mapState } from "vuex";
  import services from "@/services";
  import SfGlobalObjects from "@/utils/sf-global-objects";
  import NitroEditModal from "@/components/queries/nitro-queries/NitroEditModal";
  import AlignedTerritoriesEditModal from "../components/AlignedTerritoriesEditModal";
  import FeedbackOverviewEditModal from "@/components/queries/territory-feedback/FeedbackOverviewEditModal";
  import FeedbackChannelGoalsEditModal from "@/components/queries/territory-feedback/FeedbackChannelGoalsEditModal";
  import FeedbackProductGoalsEditModal from "@/components/queries/territory-feedback/FeedbackProductGoalsEditModal";
  import FeedbackAccountDataEditModal from "@/components/queries/territory-feedback/FeedbackAccountDataEditModal";
  import FeedbackAccountChannelGoalsEditModal
    from "@/components/queries/territory-feedback/FeedbackAccountChannelGoalsEditModal";
  import FeedbackAccountProductGoalsEditModal
    from "@/components/queries/territory-feedback/FeedbackAccountProductGoalsEditModal";
  import FeedbackAccountProductMetricsEditModal
    from "@/components/queries/territory-feedback/FeedbackAccountProductMetricsEditModal";
  import CallAttendeesEditModal from "@/components/CallAttendeesEditModal.vue";

  export default {
    name: "DataPalette",
    props: {
      appId: String,
      isDataDirty: Boolean,
      appName: String,
      appType: String,
      searchInput: String
    },
    data() {
      return {
        testRecord: "",
        displayLoader: false,
        shouldShow: true,
        app: {},
        tabIndex: 0
      };
    },
    components: {
      CallAttendeesEditModal,
      AlignedTerritoriesEditModal,
      FieldTranslationEdit,
      NewDataElementWizard,
      BaseCard,
      QueryBaseCard,
      ContextEditModal,
      VmsgEdit,
      CRMEditModal,
      OneOneEditModal,
      SummarizeEdit,
      ObjectTranslationEdit,
      SublistEditModal,
      SortListEditModal,
      MergeListEditModal,
      FilterListEditModal,
      SalesEditModal,
      Preview,
      NitroEditModal,
      TodayEditModal,
      NowEditModal,
      DropdownEditModal,
      DatepickerEditModal,
      DataEngineEditModal,
      FeedbackOverviewEditModal,
      FeedbackChannelGoalsEditModal,
      FeedbackProductGoalsEditModal,
      FeedbackAccountDataEditModal,
      FeedbackAccountChannelGoalsEditModal,
      FeedbackAccountProductGoalsEditModal,
      FeedbackAccountProductMetricsEditModal
    },
    mounted() {
      let component = this.currentApp;
      for (const de in component.dataElements) {
        if (component.dataElements[de].notReady) {
          const params = {
            appId: component.uuid,
            deId: component.dataElements[de].id
          };
          this.onDeNameChanged();
          store.commit(MUTATION_NAME.DELETE_DATA_ELEMENT, params);
        }
      }

      if (utils.getRecordTypeObject(this.currentApp.type)) {
        services
          .fetchCurrentPreviewRecord(
            this.currentApp.type,
            this.currentApp.testRecord
          )
          .then(resp => {
            if (resp) {
              this.testRecord = resp;
            }
          }, console.error);
      }

      services.updateElmCompiler(this.currentApp);
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      dataElementTypes() {
        return DATA_ELEMENT_TYPE;
      },
      dataElementTypeToLabel() {
        return DATA_ELEMENT_TYPE_TO_LABEL;
      },
      deleteLabel() {
        return this.messages.DELETE_OBJECT.Text_vod__c.replace(
          "{0}",
          this.messages.DATA_ELEMENT.Text_vod__c
        );
      },
      previewText() {
        return this.getMessageText(this.messages.PREVIEW);
      },
      testRecordName() {
        return this.testRecord.Formatted_Name_vod__c || this.testRecord.Name;
      },
      hasDes() {
        if (!this.currentApp.dataElements) {
          return false;
        }

        return (
          Object.keys(this.currentApp.dataElements).length > 0 &&
          this.currentApp.dataElements.constructor === Object
        );
      },
      deTypes() {
        const deTypesPrefix = "DATA_EL_";
        let typeMessages = [];

        for (const [key, value] of Object.entries(
          this.dataElementTypeToLabel
        )) {
          typeMessages.push({
            Name: deTypesPrefix + key,
            Text_vod__c: this.$t(String(value))
          });
        }

        //we should change this pattern in the future if we end up needing to have more data elements specific to content types
        if (this.currentApp.type !== "Call") {
          typeMessages = typeMessages.filter(
            e => e.Name !== DATA_ELEMENT_TYPE.CALL_ATTENDEES
          );
        }

        return typeMessages.map(msg => {
          msg.value = msg.Name;
          msg.text = msg.Text_vod__c;
          return msg;
        });
      },
      newDEButtonText() {
        return this.replaceMessageText(
          this.messages.ADD_ITEM,
          this.messages.DATA_ELEMENT
        );
      },
      currentApp() {
        this.updateFieldLabels();
        return utils.findAppByAppId(this.apps, this.appId);
      },
      updatedApp() {
        return this.app;
      }
    },
    methods: {
      onDeNameChanged() {
        this.shouldShow = null;
        this.$nextTick(() => {
          this.shouldShow = true;
        });
      },
      isMergeList(de) {
        return de.type === "DATA_EL_MERGE_LIST";
      },
      getHeaderClass(de) {
        if (this.isMergeList(de)) {
          return "de-header de-header-merge-list";
        }
        return "de-header";
      },
      onTabClicked(index) {
        this.tabIndex = index;
      },
      isActiveTab(index) {
        return index === this.tabIndex;
      },
      refreshPreview(deId) {
        this.$refs["preview-" + deId][0].isReady = false;
        setTimeout(() => (this.$refs["preview-" + deId][0].isReady = true), 50);
      },
      getQueryModalId(type, id) {
        return EDIT_MODAL_TYPES[type] + id;
      },
      shouldHideDelete(type) {
        return (
          type === DATA_ELEMENT_TYPE.DROPDOWN ||
          type === DATA_ELEMENT_TYPE.DATEPICKER
        );
      },
      deleteElement(id) {
        let component = this;
        this.$bvModal
          .msgBoxConfirm(this.messages.ARE_YOU_SURE.Text_vod__c, {
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.messages.OK.Text_vod__c,
            cancelTitle: this.messages.CANCEL.Text_vod__c,
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              const params = {
                appId: component.currentApp.uuid,
                deId: id
              };

              this.onDeNameChanged();
              store.commit(MUTATION_NAME.DELETE_DATA_ELEMENT, params);
            }
          })
          .catch(err => {
            console.error(err);
            // An error occurred
          });
      },
      onDECreated(deId) {
        const createdDe = this.currentApp.dataElements[deId];

        if (createdDe) {
          let modalName = EDIT_MODAL_TYPES[createdDe.type];
          if (modalName) {
            setTimeout(() => this.$bvModal.show(modalName + deId), 10);
          }
        }
      },
      onDECreateModalClose() {
        this.updateFieldLabels();
        services.updateElmCompiler(this.currentApp);
      },
      updateFieldLabels: debounce(function() {
        this.displayLoader = true;
        SfGlobalObjects.updateApp(
          this.currentApp,
          SfGlobalObjects.updateFieldLabels
        ).then(
          res => {
            this.app = res;
            this.displayLoader = false;
          },
          () => {
            this.app = this.currentApp;
            this.displayLoader = false;
          }
        );
      }, 100)
    }
  };
</script>

<style scoped>
  .create-element-container {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 1px solid var(--BORDER_GREY);
  }

  .element-btn-wrapper {
    margin-right: 1rem;
  }

  .create-element-btn,
  .de-edit-btn {
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: #0070d2;
    -webkit-appearance: none;
    white-space: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .de-header-row {
    display: flex;
  }

  .de-btn-wrapper {
    margin-left: auto;
  }

  .de-edit-btn {
    font-size: 1rem;
  }

  .de-title {
    display: flex;
    font-size: 1rem;
    font-weight: bold;
    flex: 1 1;
    min-width: 0;
    padding-right: 0.7rem;
    max-width: 50%;
  }

  .action-row {
    margin-top: 2rem;
  }

  .preview-wrapper {
    margin-top: 2rem;
  }
  .preview-content {
    overflow-x: auto;
  }

  .modal-btn {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 0;
    background: transparent;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    line-height: 1.875rem;
    color: var(--BTN_BG_BLUE);
    -webkit-appearance: none;
    white-space: normal;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-decoration: none;
  }

  .delete-btn {
    padding-left: 1rem;
    padding-right: 1rem;
    text-align: center;
    vertical-align: middle;
    justify-content: center;
    transition: border 0.15s linear;
    background-color: var(--SF_ERROR_RED);
    border: 1px solid var(--SF_ERROR_RED);
    color: var(--WHITE);
  }

  .de-refresh-icon {
    height: 1.5rem;
    width: 1.5rem;
    fill: var(--BTN_BG_BLUE);
    cursor: pointer;
  }

  .test-record {
    margin-right: 1rem;
    margin-left: auto;
  }

  .de-description {
    overflow-wrap: break-word;
  }
</style>
